export default __webpack_public_path__ + "static/media/Log_In.56debda4.svg";